<template>
    <b-row v-if="jsonDataReady">
        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <rsa-scheda-aachener-aphasie-test-dati-generali-edit-component :jsonData="jsonData" :limitiRisultati="limitiRisultati" :isReadOnly="isReadOnly"></rsa-scheda-aachener-aphasie-test-dati-generali-edit-component>
            <rsa-scheda-aachener-aphasie-test-linguaggio-spontaneo-edit-component :jsonDataLinguaggioSpontaneo="jsonData.aachenerAphasieTestLinguaggioSpontaneoBean" :isReadOnly="isReadOnly"></rsa-scheda-aachener-aphasie-test-linguaggio-spontaneo-edit-component>
            <rsa-scheda-aachener-aphasie-test-gettoni-edit-component :jsonDataGettoni="jsonData.aachenerAphasieTestGettoniBean" :isReadOnly="isReadOnly"></rsa-scheda-aachener-aphasie-test-gettoni-edit-component>
            <rsa-scheda-aachener-aphasie-test-ripetizione-edit-component :jsonDataRipetizione="jsonData.aachenerAphasieTestRipetizioneBean" :isReadOnly="isReadOnly"></rsa-scheda-aachener-aphasie-test-ripetizione-edit-component>
            <rsa-scheda-aachener-aphasie-test-linguaggio-scritto-edit-component :jsonDataLinguaggioScritto="jsonData.aachenerAphasieTestLinguaggioScrittoBean" :isReadOnly="isReadOnly"></rsa-scheda-aachener-aphasie-test-linguaggio-scritto-edit-component>
            <rsa-scheda-aachener-aphasie-test-denominazione-edit-component :jsonDataDenominazione="jsonData.aachenerAphasieTestDenominazioneBean" :isReadOnly="isReadOnly"></rsa-scheda-aachener-aphasie-test-denominazione-edit-component>
            <rsa-scheda-aachener-aphasie-test-scrittura-mano-edit-component :jsonDataLinguaggioScritto="jsonData.aachenerAphasieTestLinguaggioScrittoBean" :isReadOnly="isReadOnly"></rsa-scheda-aachener-aphasie-test-scrittura-mano-edit-component>
            <rsa-scheda-aachener-aphasie-test-comprensione-edit-component :jsonDataComprensione="jsonData.aachenerAphasieTestComprensioneBean" :isReadOnly="isReadOnly"></rsa-scheda-aachener-aphasie-test-comprensione-edit-component>
        </b-col>
    </b-row>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import moment from "moment";
import RsaSchedaAachenerAphasieTestDatiGeneraliEditComponent from "./RsaSchedaAachenerAphasieTestDatiGeneraliEditComponent.vue";
import RsaSchedaAachenerAphasieTestLinguaggioSpontaneoEditComponent from "./RsaSchedaAachenerAphasieTestLinguaggioSpontaneoEditComponent.vue";
import RsaSchedaAachenerAphasieTestGettoniEditComponent from "./RsaSchedaAachenerAphasieTestGettoniEditComponent.vue";
import RsaSchedaAachenerAphasieTestRipetizioneEditComponent from "./RsaSchedaAachenerAphasieTestRipetizioneEditComponent.vue";
import RsaSchedaAachenerAphasieTestLinguaggioScrittoEditComponent from "./RsaSchedaAachenerAphasieTestLinguaggioScrittoEditComponent.vue";
import RsaSchedaAachenerAphasieTestDenominazioneEditComponent from "./RsaSchedaAachenerAphasieTestDenominazioneEditComponent.vue";
import RsaSchedaAachenerAphasieTestScritturaManoEditComponent from "./RsaSchedaAachenerAphasieTestScritturaManoEditComponent.vue";
import RsaSchedaAachenerAphasieTestComprensioneEditComponent from "./RsaSchedaAachenerAphasieTestComprensioneEditComponent.vue";

export default {
    name: "RsaSchedaAachenerAphasieTestEditComponent",
    mixins: [UtilityMixin],
    components: {
        RsaSchedaAachenerAphasieTestDatiGeneraliEditComponent,
        RsaSchedaAachenerAphasieTestLinguaggioSpontaneoEditComponent,
        RsaSchedaAachenerAphasieTestGettoniEditComponent,
        RsaSchedaAachenerAphasieTestRipetizioneEditComponent,
        RsaSchedaAachenerAphasieTestLinguaggioScrittoEditComponent,
        RsaSchedaAachenerAphasieTestDenominazioneEditComponent,
        RsaSchedaAachenerAphasieTestScritturaManoEditComponent,
        RsaSchedaAachenerAphasieTestComprensioneEditComponent,
    },
    props: {
        isReadOnly: { type: Boolean, default: false },
    },
    data() {
        return {
            idRisorsa: null,
            idAccettazione: null,
            pathResource: "/aacheneraphasietest",
            jsonDataReady: false,
            limitiRisultati: {
                linguaggioSpontaneo: { label: "Linguaggio spontaneo", min: 0, max: 5 },
                testGettoni: { label: "Test dei Gettoni (errori)", min: 0, max: 50 },
                ripetizione: { label: "Ripetizione", min: 0, max: 150 },
                linguaggioScritto: { label: "Linguaggio scritto", min: 0, max: 90 },
                denominazione: { label: "Denominazione", min: 0, max: 120 },
                comprensione: { label: "Comprensione", min: 0, max: 120 },
            },
            jsonData: {
                id: null,
                idAccettazione: null,
                dataTestUno: null,
                dataNascita: null,
                eta: null,
                dataTestDue: null,
                insorgenza: null,
                durata: null,
                linguaggioSpontaneoPunteggi: 0,
                linguaggioSpontaneoRp: 0,
                linguaggioSpontaneoPt: 0,
                linguaggioSpontaneoGravitaComplessiva: 0,
                linguaggioSpontaneoGravitaSindromeAfasica: 0,
                testGettoniPunteggi: 0,
                testGettoniRp: 0,
                testGettoniPt: 0,
                testGettoniGravitaComplessiva: 0,
                testGettoniGravitaSindromeAfasica: 0,
                ripetizionePunteggi: 0,
                ripetizioneRp: 0,
                ripetizionePt: 0,
                ripetizioneGravitaComplessiva: 0,
                ripetizioneGravitaSindromeAfasica: 0,
                linguaggioScrittoPunteggi: 0,
                linguaggioScrittoRp: 0,
                linguaggioScrittoPt: 0,
                linguaggioScrittoGravitaComplessiva: 0,
                linguaggioScrittoGravitaSindromeAfasica: 0,
                denominazionePunteggi: 0,
                denominazioneRp: 0,
                denominazionePt: 0,
                denominazioneGravitaComplessiva: 0,
                denominazioneGravitaSindromeAfasica: 0,
                comprensionePunteggi: 0,
                comprensioneRp: 0,
                comprensionePt: 0,
                comprensioneGravitaComplessiva: 0,
                comprensioneGravitaSindromeAfasica: 0,
                diagnosi: null,
                anamnesiNeurologica: null,
                esameNeurologico: null,
                preferenzaManuale: null,
                preferenzaManualePresente: null,
                manoDominante: null,
                esamiNeuroradiologici: null,
                esamiNeuroradiologiciData: null,
                esamiNeuroradiologiciOspedale: null,
                valutazioneNeuropsicologicaClinica: null,
                aachenerAphasieTestLinguaggioSpontaneoBean: {
                    id: null,
                    idAccettazione: null,
                    spontaneoComportamentoComunicativoPunteggio: 0,
                    spontaneoArticolazioneProsodiaPunteggio: 0,
                    spontaneoLinguaggioAutomaticoPunteggio: 0,
                    spontaneoStrutturaSemanticaPunteggio: 0,
                    spontaneoStrutturaFonemicaPunteggio: 0,
                    spontaneoStrutturaSintatticaPunteggio: 0,
                    trascrizioneNastroRegistratore: null,
                    trascrizioneNastroSede: null,
                    trascrizioneNastroNote: null,
                    storiaMalattia: null,
                    evoluzioneSintomiAttuali: null,
                    lavoroPrepensione: null,
                    famiglia: null,
                    hobby: null,
                    criterioComportamentoComunicativo: 0,
                    criterioArticolazioneProsodia: 0,
                    criterioLinguaggioAutomatico: 0,
                    criterioStrutturaSemanticoLessicale: 0,
                    criterioStrutturaFonemica: 0,
                    criterioStrutturaSintattica: 0,
                    idAachenerAphasieTest: null
                },
                aachenerAphasieTestGettoniBean: {
                    id: null,
                    idAccettazione: null,
                    provaPreliminare: null,
                    provaPreliminareEseguibile: null,
                    provaPreliminareNumero: 0,
                    tocchiQuadratoVerde: null,
                    tocchiQuadratoBianco: null,
                    tocchiCerchioNero: null,
                    tocchiQuadratoRosso: null,
                    tocchiCerchioBianco: null,
                    tocchiCerchioGiallo: null,
                    tocchiCerchioVerde: null,
                    tocchiQuadratoNero: null,
                    tocchiQuadratoGiallo: null,
                    tocchiCerchioRosso: null,
                    gettoniPartePrimaNumeroErrori: 0,
                    tocchiCerchioRossoGrande: null,
                    tocchiCerchioNeroPiccolo: null,
                    tocchiQuadratoVerdePiccolo: null,
                    tocchiCerchioBiancoGrande: null,
                    tocchiQuadratoRossoPiccolo: null,
                    tocchiQuadratoNeroGrande: null,
                    tocchiCerchioGialloPiccolo: null,
                    tocchiCerchioGialloPiccoloBis: null,
                    tocchiQuadratoGialloGrande: null,
                    tocchiCerchioVerdeGrande: null,
                    gettoniParteSecondaNumeroErrori: 0,
                    tocchiCerchioBiancoQuadratoRosso: null,
                    tocchiCerchioVerdeCerchioNero: null,
                    tocchiQuadratoBiancoCerchioGiallo: null,
                    tocchiCerchioRossoQuadratoVerde: null,
                    tocchiCerchioNeroCerchioBianco: null,
                    tocchiCerchioNeroCerchioBiancoBis: null,
                    tocchiQuadratoVerdeCerchioRosso: null,
                    tocchiCerchioGialloQuadratoBianco: null,
                    tocchiQuadratoRossoQuadratoNero: null,
                    tocchiQuadratoGialloCerchioVerde: null,
                    gettoniParteTerzaNumeroErrori: 0,
                    tocchiQuadratoVerdeGrandeCerchioBiancoPiccolo: null,
                    tocchiQuadratoGialloPiccoloQuadratoNeroPiccolo: null,
                    tocchiCerchioBiancoGrandeQuadratoGialloGrande: null,
                    tocchiQuadratoVerdePiccoloCerchioRossoGrande: null,
                    tocchiCerchioGialloPiccoloCerchioVerdePiccolo: null,
                    tocchiQuadratoRossoGrandeQuadratoRossoPiccolo: null,
                    tocchiCerchioNeroGrandeQuadratoRossoPiccolo: null,
                    tocchiQuadratoBiancoGrandeCerchioVerdeGrande: null,
                    tocchiCerchioNeroPiccoloCerchioGialloGrande: null,
                    tocchiCerchioRossoPiccoloQuadratoNeroGrande: null,
                    gettoniParteQuartaNumeroErrori: 0,
                    mettaQuadratoBiancoSopraCerchioVerde: null,
                    prendaCerchioNeroQuadratoGiallo: null,
                    tocchiLentamenteQuadratiRapidamenteCerchi: null,
                    mettaQuadratoVerdeVicinoCerchioRosso: null,
                    prendaTuttiCerchiTranneQuelloGiallo: null,
                    mettaQuadratoRossoLontanoQuadratoNero: null,
                    tocchiCerchioBiancoDopoAverPresoQuadratoGiallo: null,
                    tocchiTuttiQuadratiTranneQuelloNero: null,
                    gettoniParteQuintaIstruzioneNove: null,
                    gettoniParteQuintaIstruzioneDieci: null,
                    gettoniParteQuintaNumeroErrori: 0,
                    gettoniPunteggioTotale: 0,
                    idAachenerAphasieTest: null
                },
                aachenerAphasieTestRipetizioneBean: {
                    id: null,
                    idAccettazione: null,
                    suoniUno: null,
                    suoniUnoPunteggio: 0,
                    suoniDue: null,
                    suoniDuePunteggio: 0,
                    suoniTre: null,
                    suoniTrePunteggio: 0,
                    suoniQuattro: null,
                    suoniQuattroPunteggio: 0,
                    suoniCinque: null,
                    suoniCinquePunteggio: 0,
                    suoniSei: null,
                    suoniSeiPunteggio: 0,
                    suoniSette: null,
                    suoniSettePunteggio: 0,
                    suoniOtto: null,
                    suoniOttoPunteggio: 0,
                    suoniNove: null,
                    suoniNovePunteggio: 0,
                    suoniDieci: null,
                    suoniDieciPunteggio: 0,
                    suoniPartePrimaPunteggio: 0,
                    paroleAgo: null,
                    paroleAgoPunteggio: 0,
                    paroleLupo: null,
                    paroleLupoPunteggio: 0,
                    paroleElmo: null,
                    paroleElmoPunteggio: 0,
                    paroleFesta: null,
                    paroleFestaPunteggio: 0,
                    paroleOmbra: null,
                    paroleOmbraPunteggio: 0,
                    paroleSpinta: null,
                    paroleSpintaPunteggio: 0,
                    paroleNastro: null,
                    paroleNastroPunteggio: 0,
                    paroleScrigno: null,
                    paroleScrignoPunteggio: 0,
                    paroleGranchio: null,
                    paroleGranchioPunteggio: 0,
                    paroleStringa: null,
                    paroleStringaPunteggio: 0,
                    paroleParteSecondaPunteggio: 0,
                    prestitiBar: null,
                    prestitiBarPunteggio: 0,
                    prestitiFilm: null,
                    prestitiFilmPunteggio: 0,
                    prestitiTram: null,
                    prestitiTramPunteggio: 0,
                    prestitiSport: null,
                    prestitiSportPunteggio: 0,
                    prestitiSprint: null,
                    prestitiSprintPunteggio: 0,
                    prestitiValzer: null,
                    prestitiValzerPunteggio: 0,
                    prestitiSlalom: null,
                    prestitiSlalomPunteggio: 0,
                    prestitiStrudel: null,
                    prestitiStrudelPunteggio: 0,
                    prestitiGangster: null,
                    prestitiGangsterPunteggio: 0,
                    prestitiTransistor: null,
                    prestitiTransistorPunteggio: 0,
                    prestitiParteTerzaPunteggio: 0,
                    paroleComposteDivieto: null,
                    paroleComposteDivietoPunteggio: 0,
                    paroleComposteCapogiro: null,
                    paroleComposteCapogiroPunteggio: 0,
                    paroleComposteDeformazione: null,
                    paroleComposteDeformazionePunteggio: 0,
                    paroleComposteContachilometri: null,
                    paroleComposteContachilometriPunteggio: 0,
                    paroleComposteIrresponsabilita: null,
                    paroleComposteIrresponsabilitaPunteggio: 0,
                    paroleComposteFerroStiroVapore: null,
                    paroleComposteFerroStiroVaporePunteggio: 0,
                    paroleComposteDirittoPrimogenitura: null,
                    paroleComposteDirittoPrimogenituraPunteggio: 0,
                    paroleComposteModuloContoCorrentePostale: null,
                    paroleComposteModuloContoCorrentePostalePunteggio: 0,
                    paroleComposteSentenzaIncostituzionalita: null,
                    paroleComposteSentenzaIncostituzionalitaPunteggio: 0,
                    paroleComposteVerbaleMultaSostaVietata: null,
                    paroleComposteVerbaleMultaSostaVietataPunteggio: 0,
                    paroleComposteParteQuartaPunteggio: 0,
                    frasiGalloCanta: null,
                    frasiGalloCantaPunteggio: 0,
                    frasiPiccolaParlaGia: null,
                    frasiPiccolaParlaGiaPunteggio: 0,
                    frasiSiamoStatiInvitatiLui: null,
                    frasiSiamoStatiInvitatiLuiPunteggio: 0,
                    frasiIoNonTiPrestoPiuAuto: null,
                    frasiIoNonTiPrestoPiuAutoPunteggio: 0,
                    frasiCarloNonSiFaTagliareCapelli: null,
                    frasiCarloNonSiFaTagliareCapelliPunteggio: 0,
                    frasiPromessoPassareOggi: null,
                    frasiPromessoPassareOggiPunteggio: 0,
                    frasiLuiDifficileAccontentare: null,
                    frasiLuiDifficileAccontentarePunteggio: 0,
                    frasiVicinaSupermercato: null,
                    frasiVicinaSupermercatoPunteggio: 0,
                    frasiPersoneBevonoBirra: null,
                    frasiPersoneBevonoBirraPunteggio: 0,
                    frasiUomoAutoAmmalato: null,
                    frasiUomoAutoAmmalatoPunteggio: 0,
                    frasiParteQuintaPunteggio: 0,
                    ripetizionePunteggioTotale: 0,
                    idAachenerAphasieTest: null
                },
                aachenerAphasieTestLinguaggioScrittoBean: {
                    id: null,
                    idAccettazione: null,
                    letturaErba: null,
                    letturaErbaPunteggio: 0,
                    letturaBiglia: null,
                    letturaBigliaPunteggio: 0,
                    letturaMaschio: null,
                    letturaMaschioPunteggio: 0,
                    letturaSciopero: null,
                    letturaScioperoPunteggio: 0,
                    letturaCamper: null,
                    letturaCamperPunteggio: 0,
                    letturaFormazione: null,
                    letturaFormazionePunteggio: 0,
                    letturaStendibiancheria: null,
                    letturaStendibiancheriaPunteggio: 0,
                    letturaTuHaiMioLibro: null,
                    letturaTuHaiMioLibroPunteggio: 0,
                    letturaLeiCercavaEssereFelice: null,
                    letturaLeiCercavaEssereFelicePunteggio: 0,
                    letturaDoveTeDevoLasciare: null,
                    letturaDoveTeDevoLasciarePunteggio: 0,
                    letturaPartePrimaPunteggio: 0,
                    dettatoComposizioneOrma: null,
                    dettatoComposizioneOrmaPunteggio: 0,
                    dettatoComposizioneSoglia: null,
                    dettatoComposizioneSogliaPunteggio: 0,
                    dettatoComposizioneMuschio: null,
                    dettatoComposizioneMuschioPunteggio: 0,
                    dettatoComposizioneSciabola: null,
                    dettatoComposizioneSciabolaPunteggio: 0,
                    dettatoComposizionePoster: null,
                    dettatoComposizionePosterPunteggio: 0,
                    dettatoComposizioneSalvataggio: null,
                    dettatoComposizioneSalvataggioPunteggio: 0,
                    dettatoComposizionePortasciugamano: null,
                    dettatoComposizionePortasciugamanoPunteggio: 0,
                    dettatoComposizioneLuiVuoleSuaMano: null,
                    dettatoComposizioneLuiVuoleSuaManoPunteggio: 0,
                    dettatoComposizioneLeiCredeEssereSalva: null,
                    dettatoComposizioneLeiCredeEssereSalvaPunteggio: 0,
                    dettatoComposizionePercheMeVuolePortare: null,
                    dettatoComposizionePercheMeVuolePortarePunteggio: 0,
                    dettatoComposizioneParteSecondaPunteggio: 0,
                    dettatoManoOnda: null,
                    dettatoManoOndaPunteggio: 0,
                    dettatoManoTiglio: null,
                    dettatoManoTiglioPunteggio: 0,
                    dettatoManoVischio: null,
                    dettatoManoVischioPunteggio: 0,
                    dettatoManoScivolo: null,
                    dettatoManoScivoloPunteggio: 0,
                    dettatoManoCorner: null,
                    dettatoManoCornerPunteggio: 0,
                    dettatoManoFondazione: null,
                    dettatoManoFondazionePunteggio: 0,
                    dettatoManoMotociclista: null,
                    dettatoManoMotociclistaPunteggio: 0,
                    dettatoManoVoiAveteVostraParte: null,
                    dettatoManoVoiAveteVostraPartePunteggio: 0,
                    dettatoManoEgliPensavaEssereMalato: null,
                    dettatoManoEgliPensavaEssereMalatoPunteggio: 0,
                    dettatoManoPercheMeVuolePortare: null,
                    dettatoManoPercheMeVuolePortarePunteggio: 0,
                    dettatoManoParteTerzaPunteggio: 0,
                    linguaggioScrittoPunteggioTotale: 0,
                    dettatoComposizioneProvaPreliminareUno: null,
                    dettatoComposizioneProvaPreliminareSei: null,
                    linguaggioScrittoManoUsata: null,
                    linguaggioScrittoNote: null,
                    linguaggioScrittoOsservazioni: null,
                    idAachenerAphasieTest: null
                },
                aachenerAphasieTestDenominazioneBean: {
                    id: null,
                    idAccettazione: null,
                    oggettiLetto: null,
                    oggettiLettoPunteggio: 0,
                    oggettiLibro: null,
                    oggettiLibroPunteggio: 0,
                    oggettiValigia: null,
                    oggettiValigiaPunteggio: 0,
                    oggettiScopa: null,
                    oggettiScopaPunteggio: 0,
                    oggettiCintura: null,
                    oggettiCinturaPunteggio: 0,
                    oggettiPipa: null,
                    oggettiPipaPunteggio: 0,
                    oggettiMartello: null,
                    oggettiMartelloPunteggio: 0,
                    oggettiCandela: null,
                    oggettiCandelaPunteggio: 0,
                    oggettiBilancia: null,
                    oggettiBilanciaPunteggio: 0,
                    oggettiTrattore: null,
                    oggettiTrattorePunteggio: 0,
                    oggettiPartePrimaPunteggio: 0,
                    coloriRosso: null,
                    coloriRossoPunteggio: 0,
                    coloriBianco: null,
                    coloriBiancoPunteggio: 0,
                    coloriVerde: null,
                    coloriVerdePunteggio: 0,
                    coloriNero: null,
                    coloriNeroPunteggio: 0,
                    coloriGiallo: null,
                    coloriGialloPunteggio: 0,
                    coloriBluAzzurro: null,
                    coloriBluAzzurroPunteggio: 0,
                    coloriMarrone: null,
                    coloriMarronePunteggio: 0,
                    coloriGrigio: null,
                    coloriGrigioPunteggio: 0,
                    coloriViola: null,
                    coloriViolaPunteggio: 0,
                    coloriArancione: null,
                    coloriArancionePunteggio: 0,
                    coloriParteSecondaPunteggio: 0,
                    nomiCompostiAspirapolvere: null,
                    nomiCompostiAspirapolverePunteggio: 0,
                    nomiCompostiLavapiattiLavastoviglie: null,
                    nomiCompostiLavapiattiLavastovigliePunteggio: 0,
                    nomiCompostiGrattacielo: null,
                    nomiCompostiGrattacieloPunteggio: 0,
                    nomiCompostiCavatappiCavaturaccioli: null,
                    nomiCompostiCavatappiCavaturaccioliPunteggio: 0,
                    nomiCompostiGiradischiGrammofono: null,
                    nomiCompostiGiradischiGrammofonoPunteggio: 0,
                    nomiCompostiApriscatola: null,
                    nomiCompostiApriscatolaPunteggio: 0,
                    nomiCompostiBattipanniBattitappeti: null,
                    nomiCompostiBattipanniBattitappetiPunteggio: 0,
                    nomiCompostiCacciavite: null,
                    nomiCompostiCacciavitePunteggio: 0,
                    nomiCompostiMappamondo: null,
                    nomiCompostiMappamondoPunteggio: 0,
                    nomiCompostiSchiaccianoci: null,
                    nomiCompostiSchiaccianociPunteggio: 0,
                    nomiCompostiParteTerzaPunteggio: 0,
                    figureUomoMendica: null,
                    figureUomoMendicaPunteggio: 0,
                    figureDonnaColaPasta: null,
                    figureDonnaColaPastaPunteggio: 0,
                    figureRagazzoGiocaCane: null,
                    figureRagazzoGiocaCanePunteggio: 0,
                    figureUomoPescaStivale: null,
                    figureUomoPescaStivalePunteggio: 0,
                    figureRagazzoRompeTazza: null,
                    figureRagazzoRompeTazzaPunteggio: 0,
                    figurePadreFiglioGiocanoPallone: null,
                    figurePadreFiglioGiocanoPallonePunteggio: 0,
                    figurePoliziottoArrestaLadro: null,
                    figurePoliziottoArrestaLadroPunteggio: 0,
                    figureDueUominiSiSalutano: null,
                    figureDueUominiSiSalutanoPunteggio: 0,
                    figureMaestraInterrogaBambina: null,
                    figureMaestraInterrogaBambinaPunteggio: 0,
                    figureUomoDivanoGiornale: null,
                    figureUomoDivanoGiornalePunteggio: 0,
                    figureParteQuartaPunteggio: 0,
                    denominazionePunteggioTotale: 0,
                    idAachenerAphasieTest: null
                },
                aachenerAphasieTestComprensioneBean: {
                    id: null,
                    idAccettazione: null,
                    comprensioneOraleParoleCammelloRisposta: null,
                    comprensioneOraleParoleCammelloNote: null,
                    comprensioneOraleParoleCammelloPunteggio: 0,
                    comprensioneOraleParoleCapraRisposta: null,
                    comprensioneOraleParoleCapraNote: null,
                    comprensioneOraleParoleCapraPunteggio: 0,
                    comprensioneOraleParoleParacarroRisposta: null,
                    comprensioneOraleParoleParacarroNote: null,
                    comprensioneOraleParoleParacarroPunteggio: 0,
                    comprensioneOraleParoleAutostradaRisposta: null,
                    comprensioneOraleParoleAutostradaNote: null,
                    comprensioneOraleParoleAutostradaPunteggio: 0,
                    comprensioneOraleParoleScalaMobileRisposta: null,
                    comprensioneOraleParoleScalaMobileNote: null,
                    comprensioneOraleParoleScalaMobilePunteggio: 0,
                    comprensioneOraleParoleForcaRisposta: null,
                    comprensioneOraleParoleForcaNote: null,
                    comprensioneOraleParoleForcaPunteggio: 0,
                    comprensioneOraleParoleArcoRisposta: null,
                    comprensioneOraleParoleArcoNote: null,
                    comprensioneOraleParoleArcoPunteggio: 0,
                    comprensioneOraleParoleCassaRisposta: null,
                    comprensioneOraleParoleCassaNote: null,
                    comprensioneOraleParoleCassaPunteggio: 0,
                    comprensioneOraleParoleViteRisposta: null,
                    comprensioneOraleParoleViteNote: null,
                    comprensioneOraleParoleVitePunteggio: 0,
                    comprensioneOraleParolePiantaRisposta: null,
                    comprensioneOraleParolePiantaNote: null,
                    comprensioneOraleParolePiantaPunteggio: 0,
                    comprensioneOraleParolePartePrimaPunteggio: 0,
                    comprensioneOraleFrasiPadroneBellaUrlataRisposta: null,
                    comprensioneOraleFrasiPadroneBellaUrlataNote: null,
                    comprensioneOraleFrasiPadroneBellaUrlataPunteggio: 0,
                    comprensioneOraleFrasiGiornataTremendaRisposta: null,
                    comprensioneOraleFrasiGiornataTremendaNote: null,
                    comprensioneOraleFrasiGiornataTremendaPunteggio: 0,
                    comprensioneOraleFrasiAndraSubitoLettoRisposta: null,
                    comprensioneOraleFrasiAndraSubitoLettoNote: null,
                    comprensioneOraleFrasiAndraSubitoLettoPunteggio: 0,
                    comprensioneOraleFrasiUscendoLavoroUnoRisposta: null,
                    comprensioneOraleFrasiUscendoLavoroUnoNote: null,
                    comprensioneOraleFrasiUscendoLavoroUnoPunteggio: 0,
                    comprensioneOraleFrasiUscendoLavoroDueRisposta: null,
                    comprensioneOraleFrasiUscendoLavoroDueNote: null,
                    comprensioneOraleFrasiUscendoLavoroDuePunteggio: 0,
                    comprensioneOraleFrasiSpiaMaestraRisposta: null,
                    comprensioneOraleFrasiSpiaMaestraNote: null,
                    comprensioneOraleFrasiSpiaMaestraPunteggio: 0,
                    comprensioneOraleFrasiCosaStaAccadendoRisposta: null,
                    comprensioneOraleFrasiCosaStaAccadendoNote: null,
                    comprensioneOraleFrasiCosaStaAccadendoPunteggio: 0,
                    comprensioneOraleFrasiCosaLeiStaFacendoRisposta: null,
                    comprensioneOraleFrasiCosaLeiStaFacendoNote: null,
                    comprensioneOraleFrasiCosaLeiStaFacendoPunteggio: 0,
                    comprensioneOraleFrasiFraseNoveRisposta: null,
                    comprensioneOraleFrasiFraseNoveNote: null,
                    comprensioneOraleFrasiFraseNovePunteggio: 0,
                    comprensioneOraleFrasiFraseDieciRisposta: null,
                    comprensioneOraleFrasiFraseDieciNote: null,
                    comprensioneOraleFrasiFraseDieciPunteggio: 0,
                    comprensioneOraleFrasiParteSecondaPunteggio: 0,
                    comprensioneScrittaParolePalmoRisposta: null,
                    comprensioneScrittaParolePalmoNote: null,
                    comprensioneScrittaParolePalmoPunteggio: 0,
                    comprensioneScrittaParoleFarfallaRisposta: null,
                    comprensioneScrittaParoleFarfallaNote: null,
                    comprensioneScrittaParoleFarfallaPunteggio: 0,
                    comprensioneScrittaParoleSalvagenteRisposta: null,
                    comprensioneScrittaParoleSalvagenteNote: null,
                    comprensioneScrittaParoleSalvagentePunteggio: 0,
                    comprensioneScrittaParoleMonopattinoRisposta: null,
                    comprensioneScrittaParoleMonopattinoNote: null,
                    comprensioneScrittaParoleMonopattinoPunteggio: 0,
                    comprensioneScrittaParoleSediaSdraioRisposta: null,
                    comprensioneScrittaParoleSediaSdraioNote: null,
                    comprensioneScrittaParoleSediaSdraioPunteggio: 0,
                    comprensioneScrittaParoleChiaveRisposta: null,
                    comprensioneScrittaParoleChiaveNote: null,
                    comprensioneScrittaParoleChiavePunteggio: 0,
                    comprensioneScrittaParoleFondinaRisposta: null,
                    comprensioneScrittaParoleFondinaNote: null,
                    comprensioneScrittaParoleFondinaPunteggio: 0,
                    comprensioneScrittaParoleSirenaRisposta: null,
                    comprensioneScrittaParoleSirenaNote: null,
                    comprensioneScrittaParoleSirenaPunteggio: 0,
                    comprensioneScrittaParoleSportelloRisposta: null,
                    comprensioneScrittaParoleSportelloNote: null,
                    comprensioneScrittaParoleSportelloPunteggio: 0,
                    comprensioneScrittaParoleSpinaRisposta: null,
                    comprensioneScrittaParoleSpinaNote: null,
                    comprensioneScrittaParoleSpinaPunteggio: 0,
                    comprensioneScrittaParoleParteTerzaPunteggio: 0,
                    comprensioneScrittaFrasiCausaLiteRisposta: null,
                    comprensioneScrittaFrasiCausaLiteNote: null,
                    comprensioneScrittaFrasiCausaLitePunteggio: 0,
                    comprensioneScrittaFrasiSiSonoInnamoratiRisposta: null,
                    comprensioneScrittaFrasiSiSonoInnamoratiNote: null,
                    comprensioneScrittaFrasiSiSonoInnamoratiPunteggio: 0,
                    comprensioneScrittaFrasiArrampicandosiRisposta: null,
                    comprensioneScrittaFrasiArrampicandosiNote: null,
                    comprensioneScrittaFrasiArrampicandosiPunteggio: 0,
                    comprensioneScrittaFrasiFiniraPrigioneRisposta: null,
                    comprensioneScrittaFrasiFiniraPrigioneNote: null,
                    comprensioneScrittaFrasiFiniraPrigionePunteggio: 0,
                    comprensioneScrittaFrasiMammaBellaUrlataRisposta: null,
                    comprensioneScrittaFrasiMammaBellaUrlataNote: null,
                    comprensioneScrittaFrasiMammaBellaUrlataPunteggio: 0,
                    comprensioneScrittaFrasiLuiCostringeRisposta: null,
                    comprensioneScrittaFrasiLuiCostringeNote: null,
                    comprensioneScrittaFrasiLuiCostringePunteggio: 0,
                    comprensioneScrittaFrasiCosaAccadendoRisposta: null,
                    comprensioneScrittaFrasiCosaAccadendoNote: null,
                    comprensioneScrittaFrasiCosaAccadendoPunteggio: 0,
                    comprensioneScrittaFrasiDoveLeiRisposta: null,
                    comprensioneScrittaFrasiDoveLeiNote: null,
                    comprensioneScrittaFrasiDoveLeiPunteggio: 0,
                    comprensioneScrittaFrasiDoveLuiSaleRisposta: null,
                    comprensioneScrittaFrasiDoveLuiSaleNote: null,
                    comprensioneScrittaFrasiDoveLuiSalePunteggio: 0,
                    comprensioneScrittaFrasiCosaLuiFaRisposta: null,
                    comprensioneScrittaFrasiCosaLuiFaNote: null,
                    comprensioneScrittaFrasiCosaLuiFaPunteggio: 0,
                    comprensioneScrittaFrasiParteQuartaPunteggio: 0,
                    comprensionePunteggioTotale: 0,
                    comprensioneScrittaTotale: 0,
                    idAachenerAphasieTest: null
                }
            },
        };
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                let me = this;
                if (me.jsonDataReady) {
                    me.calcolaTotali(jsonData);
                    me.$emit("update", jsonData);
                }
            },
            deep: true,
        },
    },
    methods: {
        init(idAccettazione, idRisorsa) {
            let me = this;
            me.idAccettazione = idAccettazione;
            me.idRisorsa = idRisorsa;
            me.jsonDataReady = false;
            me.jsonData = me.$options.data.call(me).jsonData;
            me.loadData();
        },
        loadData() {
            let me = this;
            if (!me.idRisorsa) {
                [
                    "spontaneoComportamentoComunicativoPunteggio",
                    "spontaneoArticolazioneProsodiaPunteggio",
                    "spontaneoLinguaggioAutomaticoPunteggio",
                    "spontaneoStrutturaSemanticaPunteggio",
                    "spontaneoStrutturaFonemicaPunteggio",
                    "spontaneoStrutturaSintatticaPunteggio",
                    "criterioComportamentoComunicativo",
                    "criterioArticolazioneProsodia",
                    "criterioLinguaggioAutomatico",
                    "criterioStrutturaSemanticoLessicale",
                    "criterioStrutturaFonemica",
                    "criterioStrutturaSintattica",
                ].forEach((field) => {
                    me.jsonData.aachenerAphasieTestLinguaggioSpontaneoBean[field] = null;
                });
                Object.keys(me.jsonData.aachenerAphasieTestRipetizioneBean).forEach((field) => {
                    if (field.endsWith("Punteggio") && !field.includes("Parte")) {
                        me.jsonData.aachenerAphasieTestRipetizioneBean[field] = null;
                    }
                });
                Object.keys(me.jsonData.aachenerAphasieTestLinguaggioScrittoBean).forEach((field) => {
                    if (field.endsWith("Punteggio") && !["letturaPartePrimaPunteggio", "dettatoComposizioneParteSecondaPunteggio", "dettatoManoParteTerzaPunteggio"].includes(field)) {
                        me.jsonData.aachenerAphasieTestLinguaggioScrittoBean[field] = null;
                    }
                });
                Object.keys(me.jsonData.aachenerAphasieTestDenominazioneBean).forEach((field) => {
                    if (field.endsWith("Punteggio") && !["oggettiPartePrimaPunteggio", "coloriParteSecondaPunteggio", "nomiCompostiParteTerzaPunteggio", "figureParteQuartaPunteggio"].includes(field)) {
                        me.jsonData.aachenerAphasieTestDenominazioneBean[field] = null;
                    }
                });
                me.jsonData.idAccettazione = me.idAccettazione;
                me.jsonData.aachenerAphasieTestLinguaggioSpontaneoBean.idAccettazione = me.idAccettazione;
                me.jsonData.aachenerAphasieTestGettoniBean.idAccettazione = me.idAccettazione;
                me.jsonData.aachenerAphasieTestRipetizioneBean.idAccettazione = me.idAccettazione;
                me.jsonData.aachenerAphasieTestLinguaggioScrittoBean.idAccettazione = me.idAccettazione;
                me.jsonData.aachenerAphasieTestDenominazioneBean.idAccettazione = me.idAccettazione;
                me.jsonData.aachenerAphasieTestComprensioneBean.idAccettazione = me.idAccettazione;
                me.jsonDataReady = true;
                me.$emit("update", me.jsonData);
                me.$emit("afterLoadData");
                return;
            }
            me.jsonDataReady = false;
            me.$emit("beforeLoadData");
            me.loadDataResources(me.pathResource + "/" + me.idRisorsa, null, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            if (response.data.esito === false || !response.data.data || response.data.data.id == null) {
                me.loadDataError(new Error(response.data.messaggio || "Errore durante il caricamento della scheda"));
                return;
            }
            let jsonDataDefault = me.$options.data.call(me).jsonData;
            me.jsonData = Object.assign({}, jsonDataDefault, response.data.data);
            Object.keys(jsonDataDefault).forEach((field) => {
                if (field.endsWith("Bean")) {
                    me.jsonData[field] = Object.assign({}, jsonDataDefault[field], response.data.data[field] || {});
                    if (me.jsonData[field].idAccettazione == null) me.jsonData[field].idAccettazione = me.jsonData.idAccettazione;
                }
            });
            me.normalizzaDate(me.jsonData);
            me.normalizzaRisposteGettoni(me.jsonData.aachenerAphasieTestGettoniBean);
            me.calcolaTotali(me.jsonData);
            me.jsonDataReady = true;
            me.$emit("update", me.jsonData);
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            me.jsonDataReady = false;
            me.$emit("afterLoadData");
            let messaggio = error.response && error.response.data && error.response.data.messaggio ? error.response.data.messaggio : error.message;
            me.$bvToast.toast(messaggio || "Errore durante il caricamento della scheda", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        normalizzaDate(jsonData) {
            ["dataTestUno", "dataTestDue", "dataNascita", "insorgenza"].forEach((field) => {
                let value = jsonData[field];
                if (value == null || value === "") {
                    jsonData[field] = null;
                    return;
                }
                let timestamp = Number(value);
                if (Number.isFinite(timestamp)) {
                    jsonData[field] = timestamp;
                    return;
                }
                let data = moment(value, [moment.ISO_8601, "DD/MM/YYYY", "DD-MM-YYYY"], true);
                if (!data.isValid()) throw new Error("Data non valida");
                jsonData[field] = data.valueOf();
            });
        },
        convertiValoreNumerico(value) {
            if (value == null || value === "") return 0;
            let valoreNumerico = Number(value);
            if (!Number.isFinite(valoreNumerico)) throw new Error("Il valore numerico non è valido");
            return valoreNumerico;
        },
        normalizzaRisposteGettoni(jsonDataGettoni) {
            let me = this;
            let jsonDataGettoniDefault = me.$options.data.call(me).jsonData.aachenerAphasieTestGettoniBean;
            Object.keys(jsonDataGettoniDefault).forEach((field) => {
                if (field.startsWith("id") || field === "provaPreliminare" || field === "provaPreliminareEseguibile" || typeof jsonDataGettoniDefault[field] === "number") return;
                if (jsonDataGettoni[field] === "+") jsonDataGettoni[field] = "SI";
                else if (jsonDataGettoni[field] === "-") jsonDataGettoni[field] = "NO";
            });
        },
        calcolaErroriGettoni(jsonDataGettoni) {
            let numeroErroriPartePrima = [
                jsonDataGettoni.tocchiQuadratoVerde,
                jsonDataGettoni.tocchiQuadratoBianco,
                jsonDataGettoni.tocchiCerchioNero,
                jsonDataGettoni.tocchiQuadratoRosso,
                jsonDataGettoni.tocchiCerchioBianco,
                jsonDataGettoni.tocchiCerchioGiallo,
                jsonDataGettoni.tocchiCerchioVerde,
                jsonDataGettoni.tocchiQuadratoNero,
                jsonDataGettoni.tocchiQuadratoGiallo,
                jsonDataGettoni.tocchiCerchioRosso,
            ].filter((value) => value === "NO").length;
            if (jsonDataGettoni.gettoniPartePrimaNumeroErrori !== numeroErroriPartePrima) {
                jsonDataGettoni.gettoniPartePrimaNumeroErrori = numeroErroriPartePrima;
            }
            let numeroErroriParteSeconda = [
                jsonDataGettoni.tocchiCerchioRossoGrande,
                jsonDataGettoni.tocchiCerchioNeroPiccolo,
                jsonDataGettoni.tocchiQuadratoVerdePiccolo,
                jsonDataGettoni.tocchiCerchioBiancoGrande,
                jsonDataGettoni.tocchiQuadratoRossoPiccolo,
                jsonDataGettoni.tocchiQuadratoNeroGrande,
                jsonDataGettoni.tocchiCerchioGialloPiccolo,
                jsonDataGettoni.tocchiCerchioGialloPiccoloBis,
                jsonDataGettoni.tocchiQuadratoGialloGrande,
                jsonDataGettoni.tocchiCerchioVerdeGrande,
            ].filter((value) => value === "NO").length;
            if (jsonDataGettoni.gettoniParteSecondaNumeroErrori !== numeroErroriParteSeconda) {
                jsonDataGettoni.gettoniParteSecondaNumeroErrori = numeroErroriParteSeconda;
            }
            let numeroErroriParteTerza = [
                jsonDataGettoni.tocchiCerchioBiancoQuadratoRosso,
                jsonDataGettoni.tocchiCerchioVerdeCerchioNero,
                jsonDataGettoni.tocchiQuadratoBiancoCerchioGiallo,
                jsonDataGettoni.tocchiCerchioRossoQuadratoVerde,
                jsonDataGettoni.tocchiCerchioNeroCerchioBianco,
                jsonDataGettoni.tocchiCerchioNeroCerchioBiancoBis,
                jsonDataGettoni.tocchiQuadratoVerdeCerchioRosso,
                jsonDataGettoni.tocchiCerchioGialloQuadratoBianco,
                jsonDataGettoni.tocchiQuadratoRossoQuadratoNero,
                jsonDataGettoni.tocchiQuadratoGialloCerchioVerde,
            ].filter((value) => value === "NO").length;
            if (jsonDataGettoni.gettoniParteTerzaNumeroErrori !== numeroErroriParteTerza) {
                jsonDataGettoni.gettoniParteTerzaNumeroErrori = numeroErroriParteTerza;
            }
            let numeroErroriParteQuarta = [
                jsonDataGettoni.tocchiQuadratoVerdeGrandeCerchioBiancoPiccolo,
                jsonDataGettoni.tocchiQuadratoGialloPiccoloQuadratoNeroPiccolo,
                jsonDataGettoni.tocchiCerchioBiancoGrandeQuadratoGialloGrande,
                jsonDataGettoni.tocchiQuadratoVerdePiccoloCerchioRossoGrande,
                jsonDataGettoni.tocchiCerchioGialloPiccoloCerchioVerdePiccolo,
                jsonDataGettoni.tocchiQuadratoRossoGrandeQuadratoRossoPiccolo,
                jsonDataGettoni.tocchiCerchioNeroGrandeQuadratoRossoPiccolo,
                jsonDataGettoni.tocchiQuadratoBiancoGrandeCerchioVerdeGrande,
                jsonDataGettoni.tocchiCerchioNeroPiccoloCerchioGialloGrande,
                jsonDataGettoni.tocchiCerchioRossoPiccoloQuadratoNeroGrande,
            ].filter((value) => value === "NO").length;
            if (jsonDataGettoni.gettoniParteQuartaNumeroErrori !== numeroErroriParteQuarta) {
                jsonDataGettoni.gettoniParteQuartaNumeroErrori = numeroErroriParteQuarta;
            }
            let numeroErroriParteQuinta = [
                jsonDataGettoni.mettaQuadratoBiancoSopraCerchioVerde,
                jsonDataGettoni.prendaCerchioNeroQuadratoGiallo,
                jsonDataGettoni.tocchiLentamenteQuadratiRapidamenteCerchi,
                jsonDataGettoni.mettaQuadratoVerdeVicinoCerchioRosso,
                jsonDataGettoni.prendaTuttiCerchiTranneQuelloGiallo,
                jsonDataGettoni.mettaQuadratoRossoLontanoQuadratoNero,
                jsonDataGettoni.tocchiCerchioBiancoDopoAverPresoQuadratoGiallo,
                jsonDataGettoni.tocchiTuttiQuadratiTranneQuelloNero,
                jsonDataGettoni.gettoniParteQuintaIstruzioneNove,
                jsonDataGettoni.gettoniParteQuintaIstruzioneDieci,
            ].filter((value) => value === "NO").length;
            if (jsonDataGettoni.gettoniParteQuintaNumeroErrori !== numeroErroriParteQuinta) {
                jsonDataGettoni.gettoniParteQuintaNumeroErrori = numeroErroriParteQuinta;
            }
        },
        calcolaTotali(jsonData) {
            let me = this;
            me.calcolaErroriGettoni(jsonData.aachenerAphasieTestGettoniBean);
            let totaleGettoni = [
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoVerde,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoBianco,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioNero,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoRosso,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioBianco,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioGiallo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioVerde,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoNero,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoGiallo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioRosso,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioRossoGrande,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioNeroPiccolo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoVerdePiccolo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioBiancoGrande,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoRossoPiccolo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoNeroGrande,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioGialloPiccolo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioGialloPiccoloBis,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoGialloGrande,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioVerdeGrande,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioBiancoQuadratoRosso,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioVerdeCerchioNero,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoBiancoCerchioGiallo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioRossoQuadratoVerde,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioNeroCerchioBianco,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioNeroCerchioBiancoBis,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoVerdeCerchioRosso,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioGialloQuadratoBianco,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoRossoQuadratoNero,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoGialloCerchioVerde,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoVerdeGrandeCerchioBiancoPiccolo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoGialloPiccoloQuadratoNeroPiccolo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioBiancoGrandeQuadratoGialloGrande,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoVerdePiccoloCerchioRossoGrande,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioGialloPiccoloCerchioVerdePiccolo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoRossoGrandeQuadratoRossoPiccolo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioNeroGrandeQuadratoRossoPiccolo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiQuadratoBiancoGrandeCerchioVerdeGrande,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioNeroPiccoloCerchioGialloGrande,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioRossoPiccoloQuadratoNeroGrande,
                jsonData.aachenerAphasieTestGettoniBean.mettaQuadratoBiancoSopraCerchioVerde,
                jsonData.aachenerAphasieTestGettoniBean.prendaCerchioNeroQuadratoGiallo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiLentamenteQuadratiRapidamenteCerchi,
                jsonData.aachenerAphasieTestGettoniBean.mettaQuadratoVerdeVicinoCerchioRosso,
                jsonData.aachenerAphasieTestGettoniBean.prendaTuttiCerchiTranneQuelloGiallo,
                jsonData.aachenerAphasieTestGettoniBean.mettaQuadratoRossoLontanoQuadratoNero,
                jsonData.aachenerAphasieTestGettoniBean.tocchiCerchioBiancoDopoAverPresoQuadratoGiallo,
                jsonData.aachenerAphasieTestGettoniBean.tocchiTuttiQuadratiTranneQuelloNero,
                jsonData.aachenerAphasieTestGettoniBean.gettoniParteQuintaIstruzioneNove,
                jsonData.aachenerAphasieTestGettoniBean.gettoniParteQuintaIstruzioneDieci,
            ].filter((value) => value === "SI").length;
            if (jsonData.aachenerAphasieTestGettoniBean.gettoniPunteggioTotale !== totaleGettoni) {
                jsonData.aachenerAphasieTestGettoniBean.gettoniPunteggioTotale = totaleGettoni;
            }
            let totaleRipetizioneParte1 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.suoniUnoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.suoniDuePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.suoniTrePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.suoniQuattroPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.suoniCinquePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.suoniSeiPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.suoniSettePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.suoniOttoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.suoniNovePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.suoniDieciPunteggio);
            if (jsonData.aachenerAphasieTestRipetizioneBean.suoniPartePrimaPunteggio !== totaleRipetizioneParte1) {
                jsonData.aachenerAphasieTestRipetizioneBean.suoniPartePrimaPunteggio = totaleRipetizioneParte1;
            }
            let totaleRipetizioneParte2 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleAgoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleLupoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleElmoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleFestaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleOmbraPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleSpintaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleNastroPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleScrignoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleGranchioPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleStringaPunteggio);
            if (jsonData.aachenerAphasieTestRipetizioneBean.paroleParteSecondaPunteggio !== totaleRipetizioneParte2) {
                jsonData.aachenerAphasieTestRipetizioneBean.paroleParteSecondaPunteggio = totaleRipetizioneParte2;
            }
            let totaleRipetizioneParte3 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.prestitiBarPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.prestitiFilmPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.prestitiTramPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.prestitiSportPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.prestitiSprintPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.prestitiValzerPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.prestitiSlalomPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.prestitiStrudelPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.prestitiGangsterPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.prestitiTransistorPunteggio);
            if (jsonData.aachenerAphasieTestRipetizioneBean.prestitiParteTerzaPunteggio !== totaleRipetizioneParte3) {
                jsonData.aachenerAphasieTestRipetizioneBean.prestitiParteTerzaPunteggio = totaleRipetizioneParte3;
            }
            let totaleRipetizioneParte4 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteDivietoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteCapogiroPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteDeformazionePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteContachilometriPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteIrresponsabilitaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteFerroStiroVaporePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteDirittoPrimogenituraPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteModuloContoCorrentePostalePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteSentenzaIncostituzionalitaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteVerbaleMultaSostaVietataPunteggio);
            if (jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteParteQuartaPunteggio !== totaleRipetizioneParte4) {
                jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteParteQuartaPunteggio = totaleRipetizioneParte4;
            }
            let totaleRipetizioneParte5 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.frasiGalloCantaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.frasiPiccolaParlaGiaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.frasiSiamoStatiInvitatiLuiPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.frasiIoNonTiPrestoPiuAutoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.frasiCarloNonSiFaTagliareCapelliPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.frasiPromessoPassareOggiPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.frasiLuiDifficileAccontentarePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.frasiVicinaSupermercatoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.frasiPersoneBevonoBirraPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.frasiUomoAutoAmmalatoPunteggio);
            if (jsonData.aachenerAphasieTestRipetizioneBean.frasiParteQuintaPunteggio !== totaleRipetizioneParte5) {
                jsonData.aachenerAphasieTestRipetizioneBean.frasiParteQuintaPunteggio = totaleRipetizioneParte5;
            }
            let totaleRipetizione =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.suoniPartePrimaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleParteSecondaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.prestitiParteTerzaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.paroleComposteParteQuartaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestRipetizioneBean.frasiParteQuintaPunteggio);
            if (jsonData.aachenerAphasieTestRipetizioneBean.ripetizionePunteggioTotale !== totaleRipetizione) {
                jsonData.aachenerAphasieTestRipetizioneBean.ripetizionePunteggioTotale = totaleRipetizione;
            }
            let totaleLinguaggioScrittoParte1 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaErbaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaBigliaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaMaschioPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaScioperoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaCamperPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaFormazionePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaStendibiancheriaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaTuHaiMioLibroPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaLeiCercavaEssereFelicePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaDoveTeDevoLasciarePunteggio);
            if (jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaPartePrimaPunteggio !== totaleLinguaggioScrittoParte1) {
                jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaPartePrimaPunteggio = totaleLinguaggioScrittoParte1;
            }
            let totaleLinguaggioScrittoParte2 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizioneOrmaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizioneSogliaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizioneMuschioPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizioneSciabolaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizionePosterPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizioneSalvataggioPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizionePortasciugamanoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizioneLuiVuoleSuaManoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizioneLeiCredeEssereSalvaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizionePercheMeVuolePortarePunteggio);
            if (jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizioneParteSecondaPunteggio !== totaleLinguaggioScrittoParte2) {
                jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizioneParteSecondaPunteggio = totaleLinguaggioScrittoParte2;
            }
            let totaleLinguaggioScrittoParte3 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoOndaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoTiglioPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoVischioPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoScivoloPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoCornerPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoFondazionePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoMotociclistaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoVoiAveteVostraPartePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoEgliPensavaEssereMalatoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoPercheMeVuolePortarePunteggio);
            if (jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoParteTerzaPunteggio !== totaleLinguaggioScrittoParte3) {
                jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoParteTerzaPunteggio = totaleLinguaggioScrittoParte3;
            }
            let totaleLinguaggioScritto =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.letturaPartePrimaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoComposizioneParteSecondaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestLinguaggioScrittoBean.dettatoManoParteTerzaPunteggio);
            if (jsonData.aachenerAphasieTestLinguaggioScrittoBean.linguaggioScrittoPunteggioTotale !== totaleLinguaggioScritto) {
                jsonData.aachenerAphasieTestLinguaggioScrittoBean.linguaggioScrittoPunteggioTotale = totaleLinguaggioScritto;
            }
            let totaleDenominazioneParte1 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.oggettiLettoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.oggettiLibroPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.oggettiValigiaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.oggettiScopaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.oggettiCinturaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.oggettiPipaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.oggettiMartelloPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.oggettiCandelaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.oggettiBilanciaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.oggettiTrattorePunteggio);
            if (jsonData.aachenerAphasieTestDenominazioneBean.oggettiPartePrimaPunteggio !== totaleDenominazioneParte1) {
                jsonData.aachenerAphasieTestDenominazioneBean.oggettiPartePrimaPunteggio = totaleDenominazioneParte1;
            }
            let totaleDenominazioneParte2 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.coloriRossoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.coloriBiancoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.coloriVerdePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.coloriNeroPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.coloriGialloPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.coloriBluAzzurroPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.coloriMarronePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.coloriGrigioPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.coloriViolaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.coloriArancionePunteggio);
            if (jsonData.aachenerAphasieTestDenominazioneBean.coloriParteSecondaPunteggio !== totaleDenominazioneParte2) {
                jsonData.aachenerAphasieTestDenominazioneBean.coloriParteSecondaPunteggio = totaleDenominazioneParte2;
            }
            let totaleDenominazioneParte3 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiAspirapolverePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiLavapiattiLavastovigliePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiGrattacieloPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiCavatappiCavaturaccioliPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiGiradischiGrammofonoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiApriscatolaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiBattipanniBattitappetiPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiCacciavitePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiMappamondoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiSchiaccianociPunteggio);
            if (jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiParteTerzaPunteggio !== totaleDenominazioneParte3) {
                jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiParteTerzaPunteggio = totaleDenominazioneParte3;
            }
            let totaleDenominazioneParte4 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.figureUomoMendicaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.figureDonnaColaPastaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.figureRagazzoGiocaCanePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.figureUomoPescaStivalePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.figureRagazzoRompeTazzaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.figurePadreFiglioGiocanoPallonePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.figurePoliziottoArrestaLadroPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.figureDueUominiSiSalutanoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.figureMaestraInterrogaBambinaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.figureUomoDivanoGiornalePunteggio);
            if (jsonData.aachenerAphasieTestDenominazioneBean.figureParteQuartaPunteggio !== totaleDenominazioneParte4) {
                jsonData.aachenerAphasieTestDenominazioneBean.figureParteQuartaPunteggio = totaleDenominazioneParte4;
            }
            let totaleDenominazione =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.oggettiPartePrimaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.coloriParteSecondaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.nomiCompostiParteTerzaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestDenominazioneBean.figureParteQuartaPunteggio);
            if (jsonData.aachenerAphasieTestDenominazioneBean.denominazionePunteggioTotale !== totaleDenominazione) {
                jsonData.aachenerAphasieTestDenominazioneBean.denominazionePunteggioTotale = totaleDenominazione;
            }
            let totaleComprensioneParte1 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParoleCammelloPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParoleCapraPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParoleParacarroPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParoleAutostradaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParoleScalaMobilePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParoleForcaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParoleArcoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParoleCassaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParoleVitePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParolePiantaPunteggio);
            if (jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParolePartePrimaPunteggio !== totaleComprensioneParte1) {
                jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParolePartePrimaPunteggio = totaleComprensioneParte1;
            }
            let totaleComprensioneParte2 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiPadroneBellaUrlataPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiGiornataTremendaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiAndraSubitoLettoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiUscendoLavoroUnoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiUscendoLavoroDuePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiSpiaMaestraPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiCosaStaAccadendoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiCosaLeiStaFacendoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiFraseNovePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiFraseDieciPunteggio);
            if (jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiParteSecondaPunteggio !== totaleComprensioneParte2) {
                jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiParteSecondaPunteggio = totaleComprensioneParte2;
            }
            let totaleComprensioneParte3 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParolePalmoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleFarfallaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleSalvagentePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleMonopattinoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleSediaSdraioPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleChiavePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleFondinaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleSirenaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleSportelloPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleSpinaPunteggio);
            if (jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleParteTerzaPunteggio !== totaleComprensioneParte3) {
                jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleParteTerzaPunteggio = totaleComprensioneParte3;
            }
            let totaleComprensioneParte4 =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiCausaLitePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiSiSonoInnamoratiPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiArrampicandosiPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiFiniraPrigionePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiMammaBellaUrlataPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiLuiCostringePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiCosaAccadendoPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiDoveLeiPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiDoveLuiSalePunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiCosaLuiFaPunteggio);
            if (jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiParteQuartaPunteggio !== totaleComprensioneParte4) {
                jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiParteQuartaPunteggio = totaleComprensioneParte4;
            }
            let totaleComprensioneOrale =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleParolePartePrimaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneOraleFrasiParteSecondaPunteggio);
            if (jsonData.aachenerAphasieTestComprensioneBean.comprensionePunteggioTotale !== totaleComprensioneOrale) {
                jsonData.aachenerAphasieTestComprensioneBean.comprensionePunteggioTotale = totaleComprensioneOrale;
            }
            let totaleComprensioneScritta =
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaParoleParteTerzaPunteggio) +
                me.convertiValoreNumerico(jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaFrasiParteQuartaPunteggio);
            if (jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaTotale !== totaleComprensioneScritta) {
                jsonData.aachenerAphasieTestComprensioneBean.comprensioneScrittaTotale = totaleComprensioneScritta;
            }
        },
        validaRangeRisultati(jsonData) {
            let me = this;
            let campi = {
                Punteggi: "Punteggi",
                Rp: "RP",
                Pt: "PT",
                GravitaComplessiva: "Gravità complessiva",
                GravitaSindromeAfasica: "Gravità sindrome afasica",
            };
            Object.keys(me.limitiRisultati).forEach((sezione) => {
                let limite = me.limitiRisultati[sezione];
                Object.keys(campi).forEach((campo) => {
                    let valore = jsonData[sezione + campo];
                    if (valore < limite.min || valore > limite.max) {
                        throw new Error(limite.label + " - " + campi[campo] + ": inserire un valore tra " + limite.min + " e " + limite.max);
                    }
                });
            });
        },
        getJsonData() {
            let me = this;
            let jsonDataDefault = me.$options.data.call(me).jsonData;
            let jsonData = Object.assign({}, jsonDataDefault, me.jsonData);
            Object.keys(jsonDataDefault).forEach((field) => {
                if (field.endsWith("Bean")) {
                    jsonData[field] = Object.assign({}, jsonDataDefault[field], me.jsonData[field] || {});
                    if (jsonData[field].idAccettazione == null) jsonData[field].idAccettazione = jsonData.idAccettazione;
                    Object.keys(jsonDataDefault[field]).forEach((childField) => {
                        if (typeof jsonDataDefault[field][childField] === "number") {
                            jsonData[field][childField] = me.convertiValoreNumerico(jsonData[field][childField]);
                        } else if (jsonData[field][childField] === "" || jsonData[field][childField] === undefined) {
                            jsonData[field][childField] = null;
                        }
                    });
                } else if (typeof jsonDataDefault[field] === "number") {
                    jsonData[field] = me.convertiValoreNumerico(jsonData[field]);
                } else if (jsonData[field] === "" || jsonData[field] === undefined) {
                    jsonData[field] = null;
                }
            });
            me.normalizzaDate(jsonData);
            me.normalizzaRisposteGettoni(jsonData.aachenerAphasieTestGettoniBean);
            me.calcolaTotali(jsonData);
            me.validaRangeRisultati(jsonData);
            return jsonData;
        },
    },
};
</script>
